import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }){
  const user = useSelector(s => s?.auth?.user);
  const companyInfoComplete = useSelector(s => s?.company?.complete);
  if (!user) return <Navigate to="/login" replace />;
  // if (!companyInfoComplete) return <Navigate to="/myinfo" replace />;
  return children;
}
